import Ad from "../Ad/component";

export const insertAdsAfterN = (
    items: JSX.Element[],
    n: number
): JSX.Element[] => {
    return items?.reduce(
        (list: JSX.Element[], elem: JSX.Element, i: number) => {
            list.push(elem);
            if ((i + 1) % n === 0) {
                list.push(
                    <Ad
                        type="bigbox-single"
                        lazy="true"
                        targeting={{ plc: "vv" }}
                        key={`ad- + ${i}`}
                        adContainerClasses={"bigbox-shorts"}
                    />
                );
            }
            return list;
        },
        [] as JSX.Element[]
    );
};
